import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPhone, FiMail, FiMapPin } = FiIcons;

const Footer = () => {
  const californiaKeywords = [
    { city: 'Los Angeles', slug: 'los-angeles' },
    { city: 'San Francisco', slug: 'san-francisco' },
    { city: 'San Diego', slug: 'san-diego' },
    { city: 'Sacramento', slug: 'sacramento' },
    { city: 'San Jose', slug: 'san-jose' },
    { city: 'Fresno', slug: 'fresno' },
    { city: 'Long Beach', slug: 'long-beach' },
    { city: 'Oakland', slug: 'oakland' },
    { city: 'Bakersfield', slug: 'bakersfield' },
    { city: 'Anaheim', slug: 'anaheim' },
    { city: 'Santa Ana', slug: 'santa-ana' },
    { city: 'Riverside', slug: 'riverside' },
    { city: 'Stockton', slug: 'stockton' },
    { city: 'Irvine', slug: 'irvine' },
    { city: 'Chula Vista', slug: 'chula-vista' },
    { city: 'Fremont', slug: 'fremont' },
    { city: 'San Bernardino', slug: 'san-bernardino' },
    { city: 'Modesto', slug: 'modesto' },
    { city: 'Fontana', slug: 'fontana' },
    { city: 'Oxnard', slug: 'oxnard' },
    { city: 'Moreno Valley', slug: 'moreno-valley' },
    { city: 'Huntington Beach', slug: 'huntington-beach' },
    { city: 'Glendale', slug: 'glendale' },
    { city: 'Santa Clarita', slug: 'santa-clarita' },
    { city: 'Garden Grove', slug: 'garden-grove' }
  ];

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img
                src="https://app1.sharemyimage.com/2025/05/19/burbank-insurance-services-in-california-logo.png"
                alt="Burbank Insurance"
                className="h-10"
              />
              <span className="text-xl font-bold text-blue-400">+</span>
              <img
                src="https://cdn1.sharemyimage.com/smi/2025/09/11/Coterie_Logo_Trans_FullColor-1024x185.png"
                alt="Coterie Insurance"
                className="h-6"
              />
            </div>
            <p className="text-gray-300 mb-4">
              Trusted business insurance solutions for California companies through our partnership with Coterie Insurance.
            </p>
            <p className="text-sm text-gray-400">CA License #6013543</p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Insurance Products</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/small-business-insurance"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  Small Business Insurance
                </Link>
              </li>
              <li>
                <Link
                  to="/general-liability"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  General Liability
                </Link>
              </li>
              <li>
                <Link
                  to="/professional-liability"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  Professional Liability
                </Link>
              </li>
              <li>
                <Link
                  to="/workers-compensation"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  Workers Compensation
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <div className="space-y-3">
              <a
                href="tel:8184714255"
                className="flex items-center space-x-2 text-gray-300 hover:text-white transition-colors"
              >
                <SafeIcon icon={FiPhone} className="h-4 w-4" />
                <span>(818) 471-4255</span>
              </a>
              <a
                href="mailto:info@burbanksinsuranceservices.com"
                className="flex items-center space-x-2 text-gray-300 hover:text-white transition-colors"
              >
                <SafeIcon icon={FiMail} className="h-4 w-4" />
                <span>info@burbanksinsuranceservices.com</span>
              </a>
              <div className="flex items-start space-x-2 text-gray-300">
                <SafeIcon icon={FiMapPin} className="h-4 w-4 mt-1" />
                <span>Serving all of California</span>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Get Started</h3>
            <p className="text-gray-300 mb-4">Ready to protect your business? Get a quote in minutes.</p>
            <a
              href="https://coterie.com/quote"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors"
            >
              Get My Price
            </a>
          </div>
        </div>

        {/* SEO Keywords Section */}
        <div className="mt-12 pt-8 border-t border-gray-800">
          <h4 className="text-sm font-semibold text-gray-400 mb-4">
            Small Business Insurance Coverage Areas in California
          </h4>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-2 text-xs text-gray-500">
            {californiaKeywords.map((location, index) => (
              <Link
                key={index}
                to={`/small-business-insurance-${location.slug}`}
                className="hover:text-gray-300 transition-colors cursor-pointer"
              >
                Small Business Insurance {location.city}
              </Link>
            ))}
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">© 2024 Burbank Insurance Services. All rights reserved.</p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <Link to="/about" className="text-gray-400 hover:text-white text-sm transition-colors">
              About
            </Link>
            <Link to="/contact" className="text-gray-400 hover:text-white text-sm transition-colors">
              Contact
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;